"use strict";

module.exports = function (Tenant) {
  var myTenant;
  return {
    set: function (tenant) {
      myTenant = tenant;
    },
    get: function () {
      return myTenant;
    },
    load: function (force=false) {
      var _this = this;
      if (myTenant == undefined || force)
        return Tenant.myTenant().$promise.then(function (tenant) {
          _this.set(tenant.response);
          return _this.get();
        });
      else
        return new Promise(function (res, rej) {
          res(myTenant);
        });
    },
  };
};
